import React, { useState, useContext } from "react";
import { useSiteConfig } from "../context/SiteConfigContext";
import { Link } from "react-router-dom";
import CartCanvas from "../pages/canvas/CartCanvas";
import LoginCanvas from "../pages/canvas/LoginCanvas";
import RegisterCanvas from "../pages/canvas/RegisterCanvas";
import Auth from "../utils/AuthUtils";
import { useCart } from "../context/CartContext";
import SearchCanvas from "../pages/canvas/SearchCanvas";
import { Container, Nav, Form, InputGroup } from "react-bootstrap";
import { Menu, User, Search, Heart, ShoppingBag } from "lucide-react";
import {
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaTwitter,
  FaYoutube,
} from "react-icons/fa";
import { CategoryContext } from "../context/CategoryContext";

function Header() {
  const [searchText, setSearchText] = useState("");
  const [showSearchModal, setShowSearchModal] = useState(false);
  const { cartItems } = useCart();
  const { config } = useSiteConfig();
  const isLoggedIn = Auth.getToken();
  const { categories } = useContext(CategoryContext);
  const [openId, setOpenId] = useState(null);

  const [openCategory, setOpenCategory] = useState(null);
const [openSubCategory, setOpenSubCategory] = useState(null);

const [activeCategory, setActiveCategory] = useState(null);

const handleCategoryToggle = (id) => {
  setOpenCategory(openCategory === id ? null : id);
};

const handleSubCategoryToggle = (id) => {
  setOpenSubCategory(openSubCategory === id ? null : id);
};

  const handleToggle = (id) => {
    setOpenId(openId === id ? null : id);
  };

  if (!config) return null;

  const handleModalShow = () => {
    setShowSearchModal(true);
  };




const handleMouseEnter = (e) => {
  const menu = e.currentTarget.querySelector(".mega-menu");
  if (!menu) return;

  menu.classList.remove("open-left");

  const rect = e.currentTarget.getBoundingClientRect();
  const menuWidth = menu.offsetWidth;

  if (rect.left + menuWidth > window.innerWidth) {
    menu.classList.add("open-left");
  }
};
  return (
    <>
      {/* MAIN HEADER */}

      {/* <header className="custom-header-wrapper">
        <div className="custom-header-top container-fluid px-md-5 px-3 py-2">
          <div className="d-flex justify-content-between align-items-center flex-wrap">
            <div>
              <a className="header-top-timing" href="#">
                 Future Favourites
              </a>
            </div>

            <div className="d-flex align-items-center gap-2 flex-wrap social-header">
              <span className="social-label">Social Links:</span>

              <div className="d-flex align-items-center gap-2">
                {config?.socialMedia?.facebook && (
                  <a
                    href={config?.socialMedia?.facebook}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-header-link"
                  >
                    <FaFacebook />
                  </a>
                )}

                {config?.socialMedia?.instagram && (
                  <a
                    href={config?.socialMedia?.instagram}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-header-link"
                  >
                    <FaInstagram />
                  </a>
                )}

                {config?.socialMedia?.twitter && (
                  <a
                    href={config?.socialMedia?.twitter}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-header-link"
                  >
                    <FaTwitter />
                  </a>
                )}

                {config?.socialMedia?.youtube && (
                  <a
                    href={config?.socialMedia?.youtube}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-header-link"
                  >
                    <FaYoutube />
                  </a>
                )}

                {config?.socialMedia?.linkedin && (
                  <a
                    href={config?.socialMedia?.linkedin}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-header-link"
                  >
                    <FaLinkedin />
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="custom-header-main-layer py-2 border-bottom">
          <Container fluid className="px-md-5 px-3">
            <div className="custom-header-flex">
           
              <div className="custom-header-left">
                <Link to="/" className="custom-header-logo">
                  <img src={config?.logo} alt="logo" />
                </Link>
              </div>

              <div className="custom-header-right">
                <button
                  data-bs-toggle="offcanvas"
                  data-bs-target="#shoppingCartCanvas"
                  className="custom-header-link bg-transparent border-0 p-0 d-block d-md-none"
                >
                  CART ({cartItems.length})
                </button>
                <Link
                  to="/wishlist"
                  className="d-md-none d-block text-decoration-none custom-header-link"
                >
                  <Heart size={20} />
                </Link>

                <button
                  data-bs-toggle="offcanvas"
                  data-bs-target="#mobileMenu"
                  className="custom-mobile-menu-btn d-lg-none"
                >
                  <Menu size={24} />
                </button>
              </div>

              <div className="custom-header-center d-none d-lg-flex">
                <Nav>
                  <Nav.Link as={Link} to="/" className="custom-nav-item">
                    Home
                  </Nav.Link>
                  <div className="custom-nav-dropdown">
                    <Nav.Link as={Link} to="/#" className="custom-nav-item">
                      About{" "}
                      <i
                        className="fas fa-chevron-down ms-1"
                        style={{ fontSize: "10px" }}
                      ></i>
                    </Nav.Link>
                    <div className="custom-dropdown-menu">
                      <Link to="/about-us" className="custom-dropdown-item">
                        About Us
                      </Link>
                      <Link to="/blog" className="custom-dropdown-item">
                        Blogs
                      </Link>
                      <Link to="/shop" className="custom-dropdown-item">
                        Shop
                      </Link>
                    </div>
                  </div>
                  {categories.map((cat) => (
                    <div className="custom-nav-dropdown" key={cat._id}>
                      <Nav.Link
                        as={Link}
                        to={`/categories/${cat.slugPath}`}
                        className="custom-nav-item"
                      >
                        {cat.name}
                      </Nav.Link>

                      {cat.children && cat.children.length > 0 && (
                        <div className="custom-dropdown-menu">
                          {cat.children.map((sub) => (
                            <Link
                              key={sub._id}
                              to={`/categories/${sub.slugPath}`}
                              className="custom-dropdown-item"
                            >
                              {sub.name}
                            </Link>
                          ))}
                        </div>
                      )}
                    </div>
                  ))}
                    <Nav.Link as={Link} to="/customize-cake" className="custom-nav-item">
                         Customized Cakes
                  </Nav.Link>
                  <Nav.Link
                    as={Link}
                    to="/contact-us"
                    className="custom-nav-item"
                  >
                    Contact
                  </Nav.Link>
                </Nav>
              </div>
              <div className="custom-header-right">
                <div className="custom-header-search-box d-none d-lg-block">
                  <InputGroup className="border-bottom border-dark">
                    <Form.Control
                      placeholder="Search ....."
                      className="border-0 shadow-none header-search-input"
                      value={searchText}
                      onChange={(e) => {
                        setSearchText(e.target.value);
                        setShowSearchModal(true);
                      }}
                    />
                    <Search size={18} className="search-icon" />
                  </InputGroup>
                  <SearchCanvas
                    isOpen={showSearchModal}
                    searchText={searchText}
                    setSearchText={setSearchText}
                  />
                </div>

                <Link
                  to="/wishlist"
                  className="d-md-block d-none text-decoration-none custom-header-link"
                >
                  <Heart size={20} />
                </Link>

                <div className="d-none d-lg-block">
                  {isLoggedIn ? (
                    <Link to="/users/dashboard" className="custom-header-link">
                      <User size={20} />
                    </Link>
                  ) : (
                    <Link to="/users/login" className="custom-header-link">
                      <User size={20} />
                    </Link>
                  )}
                </div>

                <button
                  data-bs-toggle="offcanvas"
                  data-bs-target="#shoppingCartCanvas"
                  className="custom-header-link bg-transparent border-0 p-0 d-none d-md-block"
                >
                  CART ({cartItems.length})
                </button>
              </div>
            </div>
          </Container>
        </div>
        <div className="custom-header-search-box d-block d-lg-none p-3 bg-muted">
          <InputGroup className="border-bottom border-dark">
            <Form.Control
              placeholder="Search ....."
              className="border-0 shadow-none header-search-input"
              value={searchText}
              onChange={(e) => {
                setSearchText(e.target.value);
                setShowSearchModal(true);
              }}
            />
            <Search size={18} className="search-icon" />
          </InputGroup>
          <SearchCanvas
            isOpen={showSearchModal}
            searchText={searchText}
            setSearchText={setSearchText}
          />
        </div>
      </header> */}







<div className="custom-header-main-layer border-bottom">

  {/* TOP ROW */}
  <Container fluid className="px-md-5 px-3">

    <div className="custom-header-top-row">

      {/* LOGO */}
      <div className="custom-header-left">
        <Link to="/" className="custom-header-logo">
          <img src={config?.logo} alt="logo" />
        </Link>
      </div>




      {/* MOBILE RIGHT ICONS */}
<div className="custom-mobile-icons d-flex d-lg-none">

  <Link
    to="/wishlist"
    className="custom-header-link text-decoration-none"
  >
    <Heart size={20} />
  </Link>

  {isLoggedIn ? (
    <Link
      to="/users/dashboard"
      className="custom-header-link text-decoration-none"
    >
      <User size={20} />
    </Link>
  ) : (
    <Link
      to="/users/login"
      className="custom-header-link text-decoration-none"
    >
      <User size={20} />
    </Link>
  )}

  <button
    data-bs-toggle="offcanvas"
    data-bs-target="#shoppingCartCanvas"
    className="custom-header-link bg-transparent border-0"
  >
    <ShoppingBag size={20} />
  </button>

  <button
    data-bs-toggle="offcanvas"
    data-bs-target="#mobileMenu"
    className="custom-mobile-menu-btn"
  >
    <Menu size={22} />
  </button>

</div>



      {/* SEARCH */}
      <div className="custom-header-search-box d-none d-lg-block">
        <InputGroup>
          <Search size={20} className="search-icon" />

          <Form.Control
            placeholder="Search For Cakes, Occasion, Flavour And More..."
            className="header-search-input"
            value={searchText}
            onChange={(e) => {
              setSearchText(e.target.value);
              setShowSearchModal(true);
            }}
          />
        </InputGroup>

        <SearchCanvas
          isOpen={showSearchModal}
          searchText={searchText}
          setSearchText={setSearchText}
        />
      </div>

      {/* RIGHT ICONS */}
      <div className="custom-header-icons  d-none d-lg-flex">

        <Link
          to="/wishlist"
          className="custom-header-link text-decoration-none"
        >
          <Heart size={22} />
        </Link>

        {isLoggedIn ? (
          <Link to="/users/dashboard" className="custom-header-link">
            <User size={22} />
          </Link>
        ) : (
          <Link to="/users/login" className="custom-header-link">
            <User size={22} />
          </Link>
        )}

        <button
          data-bs-toggle="offcanvas"
          data-bs-target="#shoppingCartCanvas"
          className="custom-header-link bg-transparent border-0"
        >
        <ShoppingBag size={22}/>  CART ({cartItems.length})
        </button>

      </div>

    </div>

  </Container>

  {/* SECOND ROW */}

  <div className="custom-navbar-row d-none d-lg-block">
    <div className="custom-mobile-search d-block d-lg-none px-3 pb-3">

  <InputGroup>

    <Search size={18} className="search-icon" />

    <Form.Control
      placeholder="Search For Cakes..."
      className="header-search-input"
      value={searchText}
      onChange={(e) => {
        setSearchText(e.target.value);
        setShowSearchModal(true);
      }}
    />

  </InputGroup>

  <SearchCanvas
    isOpen={showSearchModal}
    searchText={searchText}
    setSearchText={setSearchText}
  />

</div>

    <Container fluid className="px-md-5 px-3">

      <Nav className="justify-content-center">

        <Nav.Link as={Link} to="/" className="custom-nav-item">
          Home
        </Nav.Link>

        <div className="custom-nav-dropdown">
          <Nav.Link as={Link} to="/#" className="custom-nav-item">
            About
            <i
              className="fas fa-chevron-down ms-1"
              style={{ fontSize: "10px" }}
            />
          </Nav.Link>

          <div className="custom-dropdown-menu">
            <Link to="/about-us" className="custom-dropdown-item">
              About Us
            </Link>

            <Link to="/blog" className="custom-dropdown-item">
              Blogs
            </Link>

            <Link to="/shop" className="custom-dropdown-item">
              Shop
            </Link>
          </div>
        </div>

        {/* {categories.map((cat) => (
          <div className="custom-nav-dropdown" key={cat._id}>
            <Nav.Link
              as={Link}
              to={`/categories/${cat.slugPath}`}
              className="custom-nav-item"
            >
              {cat.name}
            </Nav.Link>

            {cat.children?.length > 0 && (
              <div className="custom-dropdown-menu">
                {cat.children.map((sub) => (
                  <Link
                    key={sub._id}
                    to={`/categories/${sub.slugPath}`}
                    className="custom-dropdown-item"
                  >
                    {sub.name}
                  </Link>
                ))}
              </div>
            )}
          </div>
        ))} */}

        {categories.map((cat,index) => (
<div
  className={`custom-nav-dropdown ${
    activeCategory?._id === cat._id && cat.children?.length
      ? "active-category"
      : ""
  }`}
  onMouseEnter={() =>
    cat.children?.length ? setActiveCategory(cat) : setActiveCategory(null)
  }
>
    <Nav.Link
      as={Link}
      to={`/categories/${cat.slugPath}`}
      className="custom-nav-item"
    >
      {cat.name}
    </Nav.Link>
  </div>
))}

{activeCategory && (
  <div
    className="mega-menu-wrapper"
    onMouseEnter={() => setActiveCategory(activeCategory)}
    onMouseLeave={() => setActiveCategory(null)}
  >
    {activeCategory.children.map((sub,index) => (
      <div key={sub._id}
      //  className="mega-menu-column"
       className={`mega-menu-column ${index % 2 === 0 ? "column-bg" : ""}`}
       >
        <Link
          to={`/categories/${sub.slugPath}`}
          className="custom-dropdown-item fw-bold   "
        >
          {sub.name}
        </Link>

        {sub.children?.map((child) => (
          <Link
            key={child._id}
            to={`/categories/${child.slugPath}`}
            className="custom-dropdown-item child-category"
          >
            {child.name}
          </Link>
        ))}
      </div>
    ))}
  </div>
)}



        <Nav.Link
          as={Link}
          to="/customize-cake"
          className="custom-nav-item"
        >
          Customized Cakes
        </Nav.Link>

        <Nav.Link
          as={Link}
          to="/contact-us"
          className="custom-nav-item"
        >
          Contact
        </Nav.Link>

      </Nav>

    </Container>

  </div>

</div>





      <div
        className="offcanvas offcanvas-end custom-cart-offcanvas"
        id="shoppingCartCanvas"
      >
        <CartCanvas />
      </div>

      <div
        className="offcanvas offcanvas-end popup-style-1 popup-shopping-cart"
        id="loginOffCanvas"
      >
        <LoginCanvas />
      </div>

      <div
        className="offcanvas offcanvas-end popup-style-1 popup-shopping-cart"
        id="registerOffCanvas"
      >
        <RegisterCanvas />
      </div>

      <div className="offcanvas offcanvas-start canvas-mb" id="mobileMenu">
        <button
          className="icon-close icon-close-popup"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        />
        <div className="mb-canvas-content">
          <div className="mb-body">
            <div className="mb-content-top">
              <ul className="nav-ul-mb" id="wrapper-menu-navigation">
                <li className="nav-mb-item">
                  <Link to="/" className="mb-menu-link">
                    Home
                  </Link>
                </li>

                {/* 2. ABOUT DROPDOWN (Toggleable) */}
                <li className="nav-mb-item">
                  <div
                    className="mb-menu-link d-flex justify-content-between align-items-center"
                    onClick={() => handleToggle("about-mb")}
                    style={{ cursor: "pointer" }}
                  >
                    About
                    {/* Symbol wala part yahan sahi kiya gaya hai */}
                    <span className="plus-minus-icon">
                      {openId === "about-mb" ? "-" : "+"}
                    </span>
                  </div>

                  {openId === "about-mb" && (
                    <div className="dropdown-menu show border-0 ps-3 bg-transparent">
                      <Link to="/about-us" className="dropdown-item py-2">
                        About Us
                      </Link>
                      <Link to="/blog" className="dropdown-item py-2">
                        Blogs
                      </Link>
                      <Link to="/shop" className="dropdown-item py-2">
                        Shop
                      </Link>
                    </div>
                  )}
                </li>

                {/* {categories.map((cat) => (
                  <li className="nav-mb-item" key={cat._id}>
                    <div
                      className="mb-menu-link nav-item-dropdown d-flex justify-content-between"
                      onClick={() => handleToggle(cat._id)}
                    >
                      {cat.name}
                      <span>{openId === cat._id ? "-" : "+"}</span>
                    </div>
                    {cat.children?.length > 0 && openId === cat._id && (
                      <div className="dropdown-menu show  border-0 ps-3 bg-transparent">
                        {cat.children.map((sub) => (
                          <Link
                            key={sub._id}
                            to={`/categories/${sub.slugPath}`}
                            className="dropdown-item"
                          >
                            {sub.name}
                          </Link>
                        ))}
                      </div>
                    )}
                  </li>
                ))} */}
{categories.map((cat) => (
  <li className="nav-mb-item" key={cat._id}>
    {/* Category */}
    <div
      className="mb-menu-link nav-item-dropdown d-flex justify-content-between"
      onClick={() => handleToggle(cat._id)}
      style={{ cursor: "pointer" }}
    >
      {cat.name}
      <span>{openId === cat._id ? "-" : "+"}</span>
    </div>

    {/* Category Children */}
    {cat.children?.length > 0 && openId === cat._id && (
      <div className="dropdown-menu show border-0 ps-3 bg-transparent">

        {cat.children.map((sub) => (
          <div key={sub._id} className="mb-2">

            {/* Sub Category */}
            <div className="d-flex justify-content-between align-items-center">

              <Link
                to={`/categories/${sub.slugPath}`}
                className="dropdown-item"
              >
                {sub.name}
              </Link>

              {sub.children?.length > 0 && (
                <span
                  style={{ cursor: "pointer" }}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    handleSubCategoryToggle(sub._id);
                  }}
                >
                  {openSubCategory === sub._id ? "-" : "+"}
                </span>
              )}

            </div>

            {/* Child Categories */}
            {sub.children?.length > 0 &&
              openSubCategory === sub._id && (
                <div className="ps-3">

                  {sub.children.map((child) => (
                    <Link
                      key={child._id}
                      to={`/categories/${child.slugPath}`}
                      className="dropdown-item"
                    >
                      {child.name}
                    </Link>
                  ))}

                </div>
              )}

          </div>
        ))}

      </div>
    )}
  </li>
))}




                  <li className="nav-mb-item">
                  <Link to="/customize-cake" className="mb-menu-link">
                     Customized Cakes
                  </Link>
                </li>
                <li className="nav-mb-item">
                  <Link to="/contact-us" className="mb-menu-link">
                    Contact
                  </Link>
                </li>
              </ul>
            </div>
            <div className="mb-other-content">
              <div className="group-icon">
                {!isLoggedIn ? (
                  <Link to="/users/login" className="shop-btn">
                    <i className="icon icon-user me-2" /> Login
                  </Link>
                ) : (
                  <Link to="/users/dashboard" className="shop-btn">
                    <i className="icon icon-user me-2" /> Dashboard
                  </Link>
                )}
              </div>
              <div className="mb-contact mb-0 border-bottom border-muted">
                <p>
                  Address:
                  <span className="ms-1">
                    {[
                      config?.address?.addressLine,
                      config?.address?.district,
                      config?.address?.state,
                    ]
                      .filter(Boolean)
                      .join(", ")}
                    {config?.address?.pincode
                      ? ` - ${config?.address.pincode}`
                      : ""}
                  </span>
                </p>
              </div>
              <ul className="pt-3">
                <li>
                  Email:
                  <b className="fw-medium">
                    <a
                      className="text-decoration-none text-secondary"
                      href={`mailto: ${config.email}`}
                    >
                      {config.email}
                    </a>
                  </b>
                </li>
                <li>
                  Phone:
                  <b className="fw-medium">
                    <a
                      className="text-decoration-none text-secondary"
                      href={`tel: ${config.phone}`}
                    >
                      +91-{config.phone}
                    </a>
                  </b>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Header;
